module.exports = __webpack_public_path__ + "static/media/boxes.df7c51f7.svg";